import { getRewardStyle } from "../utils/rewardStyles";

function RewardIcon({ icon }) {
  switch (icon) {
    case "coin":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="2" />
          <path d="M9 12h6M12 9v6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case "wallet":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 7.5A2.5 2.5 0 0 1 6.5 5H18a2 2 0 0 1 2 2v1H6.5A2.5 2.5 0 0 0 4 10.5z" fill="currentColor" opacity="0.28" />
          <path d="M4 10.5A2.5 2.5 0 0 1 6.5 8H20v8.5a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 16.5z" fill="none" stroke="currentColor" strokeWidth="2" />
          <circle cx="16.5" cy="13.5" r="1.1" fill="currentColor" />
        </svg>
      );
    case "rotate":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M20 8V4m0 0h-4m4 0-3 3a8 8 0 1 0 2.3 5.7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "crown":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 18h16l-1.4-8-4.1 3.1L12 6l-2.5 7.1L5.4 10z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
          <path d="M5 20h14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    default:
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 4v16M4 12h16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
  }
}

export default function RewardValueBadge({ value, className = "" }) {
  const style = getRewardStyle(value);
  const label = String(value || "").trim() || "--";
  const classes = ["reward-value-badge", className].filter(Boolean).join(" ");

  return (
    <span
      className={classes}
      style={{
        background: style.background,
        color: style.color,
        boxShadow: style.boxShadow,
      }}
      data-reward-type={style.type}
    >
      <span className="reward-value-badge__icon">
        <RewardIcon icon={style.icon} />
      </span>
      <span className="reward-value-badge__label">{label}</span>
    </span>
  );
}
